export class Terroir {
    static jsonMap = {
        id: 'id',
        libelle: { key: 'libelle', optional: true, default: '' },
        departements: { key: 'departements', optional: true, default: '' }
    };

    public id: number;
    public libelle: string;
    public departements: string;
}
